var _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPwShowPurple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.795 14C13.718 14 17 9 17 9s-3.282-5-8.205-5S1 9 1 9s2.872 5 7.795 5zM6.5 9a2.5 2.5 0 1 1 5 0 2.5 2.5 0 0 1-5 0zM9 5.5a3.5 3.5 0 1 0 0 7 3.5 3.5 0 0 0 0-7z",
    fill: "#6C2773"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 9,
    r: 3,
    fill: "#6C2773",
    stroke: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPwShowPurple);
export default __webpack_public_path__ + "static/media/pw_show_purple.d6a523577a5147a2b43af5a406b76fd5.svg";
export { ForwardRef as ReactComponent };